import React from 'react'
import { Button, Icon } from 'antd'
import roleService from '@services/roles'
import users from '@services/users'
import { alertPopup } from '@utils/popup'

class EditRoles extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            roles: [],
            selectedRoles: [],
            existingRoles: [],
            open: false,
            success: false
        }
    }

    componentDidMount() {
        if (this.props.userRoles) {
            let existingRoles = JSON.parse(JSON.stringify(this.props.userRoles))
            this.setState({ existingRoles, selectedRoles: existingRoles })
        }
        this.getAllRoles()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId && this.props.userRoles) {
            let existingRoles = JSON.parse(JSON.stringify(this.props.userRoles))
            this.setState({ existingRoles, selectedRoles: existingRoles })
        }

        if (!prevProps.userRoles && this.props.userRoles) {
            let existingRoles = JSON.parse(JSON.stringify(this.props.userRoles))
            this.setState({ existingRoles, selectedRoles: existingRoles })
        }
    }

    getAllRoles = () => {
        roleService.getAllRoles().then(res => {
            this.setState({ roles: res.data })
        })
    }

    updateList = values => {
        this.setState({ selectedRoles: values })
    }

    handleCheck = e => {
        let selectedRoles = [...this.state.selectedRoles]
        const { value, checked } = e.target

        if (checked && !selectedRoles.includes(value)) {
            selectedRoles.push(value)
            if (this.props.createUser) this.props.setValue(value, 'role')
        }
        !checked && selectedRoles.includes(value) && selectedRoles.splice(selectedRoles.indexOf(value), 1)

        this.setState({ selectedRoles })
    }

    save = () => {
        const { selectedRoles } = this.state
        const { userId } = this.props

        users
            .updateUserRoles({ userId, newRoles: selectedRoles })
            .then(() => {
                this.setState({ open: false, success: true })
                setTimeout(() => this.setState({ success: false }), 3000)
            })
            .catch(() => {
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'העדכון לא בוצע' })
                this.setState({ open: false })
            })
    }

    render() {
        const { open, roles, selectedRoles, existingRoles, success } = this.state
        let { width } = this.props

        return (
            <div style={{ width: width || '300px', position: 'relative' }}>
                <div style={{ ...style.bar }} onClick={() => this.setState({ open: !open })}>
                    <span>{'תפקידים'}</span>
                    <div
                        style={{
                            fontFamily: 'serif',
                            transform: open ? 'rotate(-90deg)' : 'rotate(0deg)'
                        }}
                    >
                        {success && (
                            <Icon type="check" style={{ fontSize: '16px', color: 'green', marginLeft: '15px' }} />
                        )}
                        <span>{'>'}</span>
                    </div>
                </div>
                {open && (
                    <div style={{ ...style.dropdown, position: 'absolute', width: '100%' }}>
                        <div style={{ ...style.list, marginBottom: '30px' }}>
                            {roles.map((role, index) => {
                                return (
                                    <div style={{ ...style.row }} key={index.toString()}>
                                        <input
                                            type="checkbox"
                                            value={role.slug}
                                            onChange={e => this.handleCheck(e)}
                                            checked={selectedRoles.includes(role.slug)}
                                        />
                                        <span style={{ marginRight: '10px', marginBottom: '4px' }}>{role.name}</span>
                                    </div>
                                )
                            })}
                        </div>

                        <div style={{ ...style.footer }}>
                            <Button onClick={this.save}>{'שמירה'}</Button>
                            <Button onClick={() => this.setState({ open: false, selectedRoles: existingRoles })}>
                                {'ביטול'}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const style = {
    bar: {
        backgroundColor: 'white',
        border: 'solid #e3e3e3 1px',
        borderRadius: '4px',
        padding: '4px 11px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between'
    },
    dropdown: {
        border: 'solid #e3e3e3 1px',
        borderRadius: '4px',
        marginTop: '3px',
        position: 'relative',
        zIndex: '2'
    },
    list: {
        height: '300px',
        overflowY: 'scroll',
        backgroundColor: 'white',
        padding: '15px',
        width: '100%',
        position: 'relative'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px'
    },
    footer: {
        backgroundColor: '#ECEFF2',
        borderTop: 'solid #e3e3e3 1px',
        width: '100%',
        position: 'absolute',
        bottom: '0',
        padding: '2px',
        display: 'flex',
        justifyContent: 'end'
    }
}

export default EditRoles
